import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const SuperAdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  if (token && role === 'Super_Admin') {
    return children ? children : <Outlet />;
  } else {
    return <Navigate to="/superadmin" replace />;
  }
};

export default SuperAdminProtectedRoute; 